export default [
    {
        path: '/lsrm/redirect/:path*',
        component: () => import('./lsrm/views/redirect/index')
    },
    // {
    //     path: '/lsrm/index',
    //     name: 'lsrmIndex',
    //     meta: { title: 'lsrmLang.route.index', icon: 'dispatchPopup', system: 'srm' },
    //     component: () => import('./lsrm/views/Index')
    // },
    // {
    //     path: '/lsrm/editorNotice',
    //     name: 'editorNotice',
    //     meta: { title: 'lsrmLang.route.editorNotice', icon: 'dispatchPopup', system: 'srm' },
    //     component: () => import('./lsrm/views/tendering/tenderNotice/editorNotice.vue')
    // },
    // {
    //     path: '/lsrm/previewNotice',
    //     name: 'previewNotice',
    //     meta: { title: 'lsrmLang.route.previewNotice', icon: 'dispatchPopup', system: 'srm' },
    //     component: () => import('./lsrm/views/tendering/tenderNotice/previewNotice.vue')
    // },
    {
        path: '/lsrm/tenderList',
        name: 'tenderList',
        meta: { title: 'lsrmLang.route.tenderList', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderNotice/tenderList.vue')
    },
    {
        path: '/lsrm/mipIframe',
        name: 'mipIframe',
        meta: { title: 'lsrmLang.route.mipIframe', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderNotice/mipIframe.vue')
    },
    {
        path: '/lsrm/tenderDetails',
        name: 'tenderDetails',
        meta: { title: 'lsrmLang.route.tenderDetails', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderNotice/Tenderdetails.vue')
    },
    {
        path: '/lsrm/payBidDetail',
        name: 'payBidDetail',
        meta: { title: 'lsrmLang.route.payFreight', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderNotice/payBidDetail.vue')
    },
    {
        path: '/lsrm/refundApplication',
        name: 'refundApplication',
        meta: { title: 'lsrmLang.route.refundApplication', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderCost/refundApplication.vue')
    },
    {
        path: '/lsrm/supAnnoList',
        name: 'supAnnoList',
        meta: { title: 'lsrmLang.route.supAnnoList', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/supplierAnnounce/supAnnoList.vue')
    }, {
        path: '/lsrm/supPreviewNotice',
        name: 'supPreviewNotice',
        meta: { title: 'lsrmLang.route.supPreviewNotice', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/supplierAnnounce/supPreviewNotice.vue')
    }, {
        path: '/lsrm/myBidding',
        name: 'myBidding',
        meta: { title: 'lsrmLang.route.myBidding', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/bidManagement/myBidding.vue')
    }, {
        path: '/lsrm/tenderCost',
        name: 'tenderCost',
        meta: { title: 'lsrmLang.route.tenderCost', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderCost/tenderCostList.vue')
    }, {
        path: '/lsrm/tendermanagement',
        name: 'tendermanagement',
        meta: { title: 'lsrmLang.route.tendermanagement', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderManagement/tenderManagement.vue')
    }, {
        path: '/lsrm/tenderdocument',
        redirect: '/lsrm/tenderdocument/tenderdocument',
        name: 'bidScheme',
        component: () => import('./lsrm/views/tendering/bidScheme/tenderHead.vue'),
        children: [{
            path: '/lsrm/tenderdocument/tenderdocument',
            name: 'tenderdocument',
            meta: { title: 'lsrmLang.route.tenderdocument', icon: 'dispatchPopup', system: 'srm' },
            component: () => import('./lsrm/views/tendering/tenderDocument/tenderDocument.vue')
        },
        {
            path: '/lsrm/tenderdocument/supplierbid',
            name: 'supplierbid',
            meta: { title: 'lsrmLang.route.supplierbid', icon: 'dispatchPopup', system: 'srm' },
            component: () => import('./lsrm/views/tendering/supplierBid/supplierBid.vue')
        },
        {
            path: '/lsrm/tenderdocument/graderesult',
            name: 'graderesult',
            meta: { title: 'lsrmLang.route.graderesult', icon: 'dispatchPopup', system: 'srm' },
            component: () => import('./lsrm/views/tendering/gradeResult/gradeResult.vue')
        }, {
            path: '/lsrm/tenderdocument/roundquote',
            name: 'roundquote',
            meta: { title: 'lsrmLang.route.roundquote', icon: 'dispatchPopup', system: 'srm' },
            component: () => import('./lsrm/views/tendering/roundQuote/roundQuote.vue')
        },
        {
            path: '/lsrm/tenderdocument/tenderresult',
            name: 'tenderresult',
            meta: { title: 'lsrmLang.route.tenderresult', icon: 'dispatchPopup', system: 'srm' },
            component: () => import('./lsrm/views/tendering/tenderResult/tenderResult.vue')
        } ]
    },
    {
        path: '/lsrm/tendertemplate',
        name: 'tendertemplate',
        meta: { title: 'lsrmLang.route.tendertemplate', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderTemplate/list.vue')
    },
    {
        path: '/lsrm/templatedetails',
        name: 'templatedetails',
        meta: { title: 'lsrmLang.route.templatedetails', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderTemplateDetails/tenderTemplateDetails.vue')
    },
    {
        path: '/lsrm/comprehensivegrade',
        name: 'comprehensivegrade',
        meta: { title: 'lsrmLang.route.comprehensivegrade', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/comprehensiveGrade/comprehensiveGrade.vue')
    },
    {
        path: '/lsrm/baseConfig',
        name: 'baseConfig',
        meta: { title: 'lsrmLang.route.baseConfig', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/baseConfig/Index.vue')
    },
    {
        path: '/lsrm/keyData',
        name: 'keyData',
        meta: { title: 'lsrmLang.route.keyData', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/keyData/Index.vue')
    },
    {
        path: '/lsrm/accountManage',
        name: 'accountManage',
        meta: { title: 'lsrmLang.route.accountManage', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/accountManage/Index.vue')
    },
    {
        path: '/lsrm/driverInfo',
        name: 'driverInfo',
        meta: { title: 'lsrmLang.route.driverInfo', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/workbench/driverInfo/Index.vue')
    },
    {
        path: '/lsrm/personInfo',
        name: 'personInfo',
        meta: { title: 'lsrmLang.route.personInfo', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/workbench/personInfo/Index.vue')
    },
    {
        path: '/lsrm/vehicleInfo',
        name: 'vehicleInfo',
        meta: { title: 'lsrmLang.route.vehicleInfo', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/workbench/vehicleInfo/Index.vue')
    },
    { // 叉车管理
        path: '/lsrm/forkList',
        name: 'forkList',
        meta: { title: 'lsrmLang.route.forkList', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/forkList/Index.vue')
    },
    // {
    //     path: '/lsrm/contractUphold',
    //     name: 'register',
    //     meta: { title: 'lsrmLang.route.contractUphold', icon: 'dispatchPopup', system: 'srm' },
    //     component: () => import('./lsrm/views/contract/contractUphold/Uphold')
    // },
    {
        path: '/lsrm/warningConfigure',
        name: 'register',
        meta: { title: 'lsrmLang.route.warningConfigure', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/warningConfigure/Index')
    },
    {
        path: '/lsrm/warningTask',
        name: 'warningTask',
        meta: { title: 'lsrmLang.route.warningTask', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/warningTask/Index')
    },
    {
        path: '/lsrm/contractSigning',
        name: 'contractSigning',
        meta: { title: 'lsrmLang.route.contractSigning', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/contractSigning/Index')
    },
    {
        path: '/lsrm/fileConfiguration',
        name: 'fileConfiguration',
        meta: { title: 'lsrmLang.route.fileConfiguration', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/fileConfiguration/index/Main')
    },
    {
        path: '/lsrm/payfileConfiguration',
        name: 'payfileConfiguration',
        meta: { title: 'lsrmLang.route.payfileConfiguration', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/payfileConfiguration/index/Main')
    },
    {
        path: '/lsrm/keyData/detail',
        name: 'keyDataDetail',
        meta: { title: 'lsrmLang.route.keyDataDetail', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/keyData/detail/Index.vue')
    },
    {
        path: '/lsrm/basicInfo',
        name: 'basicInfo',
        meta: { title: 'lsrmLang.route.basicInfo', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/workbench/basicInfo/Index.vue')
    },
    {
        path: '/lsrm/warehouseInfo',
        name: 'warehouseInfo',
        meta: { title: 'lsrmLang.route.warehouseInfo', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/workbench/warehouseInfo/Index.vue')
    },
    {
        path: '/lsrm/keyData/addPhysicalStorage',
        name: 'addPhysicalStorage',
        meta: { title: 'lsrmLang.route.addPhysicalStorage', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/keyData/physicalStorage/AddPhysicalStorage.vue')
    },
    {
        path: '/lsrm/keyData/physicalStorage',
        name: 'physicalStorage',
        meta: { title: 'lsrmLang.route.physicalStorage', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/register/manage/keyData/physicalStorage/physicalStorage.vue')
    },
    {
        path: '/lsrm/wtMipIframe',
        name: 'wtMipIframe',
        meta: { title: 'lsrmLang.route.wtMipIframe', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/contract/warningTask/wtMipIframe.vue')
    },
    // {
    //     path: '/lsrm/cuMipIframe',
    //     name: 'cuMipIframe',
    //     meta: { title: '合同维护流程审批', icon: 'dispatchPopup', system: 'srm' },
    //     component: () => import('./lsrm/views/contract/contractUphold/detail/cuMipIframe')
    // },
    {
        path: '/lsrm/myTender',
        name: 'myTender',
        meta: { title: 'lsrmLang.route.costDetail', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/myTender/Index.vue')
    },
    {
        path: '/lsrm/costDetail',
        name: 'costDetail',
        meta: { title: 'lsrmLang.route.payBidDetail', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderCost/costDetail.vue')
    },
    {
        path: '/lsrm/payFreight',
        name: 'payFreight',
        meta: { title: 'lsrmLang.route.payFreight', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/tendering/tenderNotice/payFreight.vue')
    },
    {
        path: '/lsrm/dayAssessHead',
        name: 'dayAssessHead',
        meta: { title: 'lsrmLang.route.dailyAssessment', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/achievementsSup/dayAssessHead.vue')
    },
    {
        path: '/lsrm/workTask',
        name: 'workTask',
        meta: { title: 'lsrmLang.route.rectificationTask', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/achievements/rectificationTask/workbench/workTask.vue')
    },
    {
        path: '/lsrm/workMonthly',
        name: 'workMonthly',
        meta: { title: 'lsrmLang.route.monthlyAssessment', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/achievements/monthlyAssessment/workbench/workMonthly.vue')
    },
    {
        path: '/lsrm/monthlyAssessScore',
        name: 'MonthlyAssessScore',
        meta: { title: 'lsrmLang.route.monthlyAssessScore', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/achievements/monthlyAssessScore/MonthlyAssessScore.vue')
    },
    {
        path: '/lsrm/rushOrderAuthApply',
        name: 'rushOrderAuthApply',
        meta: { title: 'lsrmLang.route.rushOrderAuthApply', icon: 'dispatchPopup', system: 'srm' },
        component: () => import('./lsrm/views/rushOrder/RushOrderAuthApply.vue')
    },
    {
        path: '/lsrm/driverAddSupplier',
        name: 'driverAddSupplier',
        component: () => import('./lsrm/views/register/manage/driverAddSupplier/Index.vue'),
        meta: { title: 'lsrmLang.route.driverAddSupplier', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/driverDelegateLetter',
        name: 'driverDelegateLetter',
        component: () => import('./lsrm/views/register/manage/driverDelegateManage/onlineDelegateLetter/Index.vue'),
        meta: { title: 'lsrmLang.route.driverDelegateLetter', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/legalPerform',
        name: 'legalPerform',
        component: () => import('./lsrm/views/legalPerformanceManage/legalPerform/Index.vue'),
        meta: { title: 'lsrmLang.route.legalPerform', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/performRectify',
        name: 'performRectify',
        component: () => import('./lsrm/views/legalPerformanceManage/performRectify/Index.vue'),
        meta: { title: 'lsrmLang.route.performRectify', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/warehouseDelegationLetter',
        name: 'warehouseDelegationLetter',
        component: () => import('./lsrm/views/warehouseResourceManagement/warehouseDelegationLetter/index.vue'),
        meta: { title: 'lsrmLang.route.warehouseDelegationLetter', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/warehouseDelegationApprove',
        name: 'warehouseDelegationApprove',
        component: () => import('./lsrm/views/warehouseResourceManagement/warehouseDelegationLetter/StorageDelegateDialog.vue'),
        meta: { title: 'lsrmLang.route.warehouseDelegationApprove', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/loaderSalaryConfirm',
        name: 'loaderSalaryConfirm',
        component: () => import('./lsrm/views/warehouseResourceManagement/loaderSalaryConfirm/Index.vue'),
        meta: { title: 'lsrmLang.route.loaderSalaryConfirm', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/performanceAdjustment',
        name: 'performanceAdjustment',
        component: () => import('./lsrm/views/warehouseResourceManagement/performanceAdjustment/SupIndex.vue'),
        meta: { title: 'lsrmLang.route.performanceAdjustment', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/abnormalAssess',
        name: 'abnormalAssess',
        component: () => import('./lsrm/views/warehouseResourceManagement/abnormalAssess/Index.vue'),
        meta: { title: 'lsrmLang.route.abnormalAssess', icon: 'dispatchPopup', system: 'srm' }
    },
    {
        path: '/lsrm/idleResource',
        name: 'idleResource',
        component: () => import('./lsrm/views/storageSupManage/idleResource/Index.vue'),
        meta: { title: 'lsrmLang.route.idleResource', icon: 'dispatchPopup', system: 'srm' }
    }
];
